module.exports = __webpack_public_path__ + "static/media/maya.0f2fe7c3.svg";